import "./index.css";
import "./styles/tailwind.input.css";

import { Toaster } from "@upstageai/ui";
import { observer } from "mobx-react";
import { Outlet } from "react-router-dom";

import GNBHeader from "./components/Header/GNBHeader";
import Sidebar from "./components/Sidebar/Sidebar";
import { AuthProvider } from "./context/AuthContext";
import ErrorBoundary from "./ErrorBoundary";
import { envVarStore } from "./utils/mobx/EnvVarStore";

// Start of Selection
const App = observer(() => {
  const { headerAndSidebar } = envVarStore;

  const isHeaderAndSidebar = headerAndSidebar === "true";
  const width = headerAndSidebar === "true" ? "calc(100vw - 284px)" : "100vw";

  return (
    // html, head, meta, link, body 태그는 index.html에 있음
    <div className="flex h-full w-full flex-col items-center justify-center overflow-hidden">
      <ErrorBoundary>
        <>
          <AuthProvider>
            {isHeaderAndSidebar && <GNBHeader />}
            <div className="flex">
              {isHeaderAndSidebar && <Sidebar />}
              <main
                className={`${width} desktop:rounded-ss-lg desktop:border-l`}
              >
                <Outlet />
                <Toaster />
              </main>
            </div>
          </AuthProvider>
        </>
      </ErrorBoundary>
    </div>
  );
});

export default App;
